.sn-company-logos-type-3__heading {
  text-align: center;
}

.sn-company-logos-type-3__list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: map-get($spacings, xl);
  place-items: center center;

  @include above($breakpoint-desktop) {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: var(--spacing-xl);
  }
}

.sn-company-logos-type-3__list-item {
  text-align: center;

  &:nth-child(n+5) {
    display: none;

    @include above($breakpoint-desktop-md) {
      display: block;
    }
  }

  .me-logo {
    img {
      max-height: 40px;
      width: auto;
      filter: grayscale(1);
      opacity: 0.7;

      @include above($breakpoint-desktop) {
        max-height: 56px;
      }
    }
  }
}
